import React from 'react';

import AddPayrollInformationForm from './AddPayrollInformationForm';

interface Props {
  editingUser: {
    id: number;
  } | null;
  onBack: () => void;
  onDone: () => void;
  invalidPayrollInfo: (user: any) => boolean;
  mobileTablet: boolean;
  // Pass through all other props that AddPayrollInformationForm needs
  [key: string]: any;
}

const PayrollInfoView = ({
  editingUser,
  onBack,
  onDone,
  invalidPayrollInfo,
  mobileTablet,
  ...otherProps
}: Props) => {
  if (!editingUser) {
    return null;
  }

  return (
    <AddPayrollInformationForm
      userId={editingUser.id}
      onClickBackButton={onBack}
      onClickDone={onDone}
      invalidPayrollInfo={invalidPayrollInfo}
      mobileTablet={mobileTablet}
      {...otherProps}
    />
  );
};

export default PayrollInfoView;
